import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { companyApi } from '../companyApi';
import {
  type UpdateCompanyActivityParams,
  type UpdateCompanyActivityResponse,
} from '../types';
import { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { MutationKey } from '@shared/config';

export const useUpdateActivityCompany = (
  id: string
): UseMutationResult<
  UpdateCompanyActivityResponse,
  AxiosError<TFormErrorResponse>,
  UpdateCompanyActivityParams
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_ACTIVITY_COMPANY],
    mutationFn: (params: UpdateCompanyActivityParams) =>
      companyApi.updateCompanyActivity(id, params),
  });
};
